import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';
import { NotificationData, NotificationType } from '../notification-data.model';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    selector: 'app-notification',
    imports: [MatIconModule, MatButtonModule, MatSnackBarModule],
    templateUrl: './notification.component.html',
    styleUrl: './notification.component.scss'
})
export class NotificationComponent {
  currentIcon: string;

  constructor(
    public snackBarRef: MatSnackBarRef<NotificationComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: NotificationData,
    private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
    this.addSvgFiles();
    this.currentIcon = this.setIcon();
  }

  close(): void {
    this.snackBarRef.dismiss();
  }

  setIcon(): string {
    switch (this.data.type) {
      case NotificationType.success:
        return 'check_circle';
      case NotificationType.error:
        return 'error';
      case NotificationType.warning:
        return 'warning';
      case NotificationType.info:
      default:
        return 'info';
    }
  }

  getIconAriaLabel(): string {
    switch (this.data.type) {
      case NotificationType.success:
        return 'Succes';
      case NotificationType.error:
        return 'Eroare';
      case NotificationType.warning:
        return 'Avertisment';
      case NotificationType.info:
      default:
        return 'Informație';
    }
  }

  private addSvgFiles() {
    this.matIconRegistry.addSvgIcon("close", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/close_x.svg"));
    this.matIconRegistry.addSvgIcon("check_circle", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/check-notification.svg"));
    this.matIconRegistry.addSvgIcon("error", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/error-notification.svg"));
    this.matIconRegistry.addSvgIcon("warning", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/warning-notification.svg"));
    this.matIconRegistry.addSvgIcon("info", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/info-notification.svg"));
  }
}

